import { memo } from "react";
import DialogComponent from "../../../../commons/components/Modal/DialogComponent"


type Props = {
  handleCloseUpdate: Function,
  statusDialogUpdateSuccess: Boolean,
  className: String
}

const DialogPublishSuccess = (({handleCloseUpdate, statusDialogUpdateSuccess, className}:Props) => {
  return (
    <DialogComponent 
      id={`js-update-status`} 
      show={statusDialogUpdateSuccess} 
      title={`알림`} 
      closeBtn={`확인`}  
      handleClose={handleCloseUpdate}
    >
      <div className="content-dialog video-publish-gift">
        <span className="text">감사합니다.</span> <br />
        <span className="text">회원님의 소중한 후기가 공개되었습니다.</span><br />
        <img className="img" src="/images/video_publish_gift.svg" alt="" /><br />
        <span className="text-point">+100포인트</span><span className="text">가 적립 되셨습니다.</span>
      </div>
    </DialogComponent>
  )
})

export default memo(DialogPublishSuccess);